module.exports = __webpack_public_path__ + "img/gf.f689ce44.svg";